function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.864 11.32h-.813l-.288-.277a6.66 6.66 0 001.616-4.354 6.69 6.69 0 10-6.69 6.69 6.66 6.66 0 004.354-1.616l.278.288v.813L16.467 18 18 16.466l-5.136-5.145zm-6.174 0a4.625 4.625 0 01-4.632-4.63A4.625 4.625 0 016.69 2.057a4.625 4.625 0 014.63 4.631 4.625 4.625 0 01-4.63 4.632z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.204 6.175V4.117H6.175v2.058H4.117v1.03h2.058v2.057h1.03V7.204h2.058v-1.03H7.204z",
  fill: "#fff"
});

function SvgMagnifyGlassPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMagnifyGlassPlus;